<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      ref="reservationList"
      class="my-5"
      flat
      :headers="reservationHeaders"
      :get-data-func="getReservations"
      :init-pagination="{sortBy: 'creationTime', descending: true}"
      auto-actions
      clickable
      :filter-items="filter"
      no-data-text="没有预约历史"
      hide-title-search
      @click:row="goReservation"
    >
      <template slot="title">
        <v-subheader class="px-0 pr-4">车辆预约历史</v-subheader>
      </template>
    </l-data-table>
    <l-data-table
      ref="personReservationList"
      class="my-5"
      flat
      :headers="reservationHeaders"
      :get-data-func="getPersonReservations"
      :init-pagination="{sortBy: 'creationTime', descending: true}"
      auto-actions
      clickable
      :filter-items="filter"
      no-data-text="没有预约历史"
      hide-title-search
      @click:row="goReservation"
    >
      <template slot="title">
        <v-subheader class="px-0 pr-4">行人预约历史</v-subheader>
      </template>
    </l-data-table>
    <l-data-table
      :headers="vehicleHeader"
      :get-data-func="getVehicleList"
      title-text="个人车辆列表"
      @click:row="goVehicleDetail($event.item)"
      clickable
      flat
      hide-title-search>
    </l-data-table>
  </l-layout>
</template>

<script>
  import {time} from '../../../ladmin/utils/time'
  import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
  import {Reservation, VIOLATION_STATUS_TEXT} from '../../../object'
  let typeName = {
    person: '个人预约',
    admin: '高级预约',
    org: '单位预约',
    letter_business: '商业函件预约',
    letter_work: '工作函件预约',
    letter_append: '函件预约追加',
    letter_append_self: '函件预约自助登记'
  }
  export default {
    name: "registerUserDetail",
    components: {LDataTable},
    props:{
      userId:{
        type:String,
        default:''
      }
    },
    data(){
      return {
        reservationHeaders: [
          {text: '来访人', value: 'visitorName', align: 'left', placeholder: 'N/A', sortable: false},
          {text: '联系人', value: 'ownerName', align: 'right', placeholder: 'N/A', sortable: false},
          {text: '申请人', value: 'applicantName', align: 'right', placeholder: 'N/A', sortable: false},
          {text: '预约类型', value: 'type', align: 'right', placeholder: 'N/A', sortable: false, f: (v) => (typeName[v])},
          {text: '开始时间', value: 'startDatetime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
          {text: '结束时间', value: 'endDatetime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
          {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
          {text: '是否有效', value: 'status', align: 'left', placeholder: 'N/A', f: (v) => (v === '1' ? '有效' : '失效')},
        ],
        vehicleHeader:[
          {text: '车辆号牌', value: 'plateNumber', align: 'left', sortable: false},
          {text: '车主姓名', value: 'name', align: 'left', sortable: false},
          {text: '联系方式', value: 'phone', align: 'left', sortable: false},
          {text: '提交时间', value: 'creationTime', align: 'left', f: (v) => time.stringify(v)},
          {text: '', value: ''}
        ],
        filter: [
          {
            prependIcon: '$vuetify.icons.edit',
            key: 'status',
            value: '{"r_h_status":"1"}',
            label: '是否有效',
            type: 'select',
            layout: ['xs12', 'sm4'],
            items: [
              {
                value: '',
                text: '全部'
              },
              {
                value: '{"r_h_status":"1"}',
                text: '有效'
              },
              {
                value: '{"r_h_status":"-1"}',
                text: '失效'
              }],
          },
          {
            label: '开始时间',
            layout: 'xs12, sm4',
            type: 'duration',
            key: 'startDatetime',
            value: {},
            range: true,
            f: v => {
              if (!v.startDatetime && !v.endDatetime) {
                return null
              }
              else {
                let s = time.toTimeStamp(v.startDatetime) || 0
                let e = time.toTimeStamp(v.endDatetime) || 9999999999999
                return [s, e]
              }
            }
          },
          {
            label: '截止时间',
            layout: 'xs12, sm4',
            type: 'duration',
            key: 'endDatetime',
            value: {},
            range: true,
            f: v => {
              if (!v.startDatetime && !v.endDatetime) {
                return null
              }
              else {
                let s = time.toTimeStamp(v.startDatetime) || 0
                let e = time.toTimeStamp(v.endDatetime) || 9999999999999
                return [s, e]
              }
            }
          }],
        showExtend: false,
        selected:[]
      }
    },
    methods:{
      getReservations ({pagination, sortStack, filterItems}) {
        return this.$store.dispatch('reservation/getReservations', {
          pagination: {page: 1, rowsPerPage: 5},
          sortStack,
          filter: filterItems,
          search: {
            key: 'ownerId', value: this.$route.query.loginId,
          }
        })
      },
      getPersonReservations ({pagination, sortStack, filterItems}) {
        return this.$store.dispatch('personReservation/getReservations', {
          pagination: {page: 1, rowsPerPage: 5},
          sortStack,
          filter: filterItems,
          search: {
            key: 'ownerId', value: this.$route.query.loginId,
          }
        })
      },
      async goReservation ({item}) {
        const map = {
          [Reservation.PERSONAL]: 'PersonalReservationDetails',
          [Reservation.ORG]: 'OrgReservationDetails',
          [Reservation.ADMIN]: 'AdminReservationDetails',
        }
        let routeName = map[item.type]
        if (routeName) {
          this.$router.push({
            name: routeName,
            params: {
              plate: item.plate
            },
            query: {id: item.id}
          })
        }
        else {
          let res = await this.$store.dispatch('reservation/getReservationObgrp', {ownerId: item.ownerId})
          console.log(res)
          let extend = JSON.parse(res.items[0].obgrp.extend)
          this.$router.push({
            name: 'reservationDetails',
            query: {id: extend.procInstId, status: 'read', obGrpName: ''}})
        }
      },
      async getVehicleList ({pagination, sortStack, filterItems, search}) {
        let filter = [
          {key:"userId",value:this.$route.query.id},
          {key:'status',value:"1"}
        ]
        let {items,amount} = await this.$store.dispatch('passControl/getSelfVehicleList', {pagination,filter:filter})
        let arr = []
        for(let i=0;i<items.length;i++){
          let item = items[i]
          item.plateNumber = item.vehicle.plateNumber
          item.name = item.user.name
          item.phone = item.user.mobilePhone
          item.creationTime = item.vehicle.creationTime
          arr.push(item)
        }
        return {items: arr, amount: amount}
      },
      goVehicleDetail(item){
        let selectionString = document.getSelection().toString()
        if (!selectionString) {
          // console.log(item.plate)
          this.$router.push({
            name: 'VehicleStatisticDetails',
            params: {
              plate: item.plateNumber || ''
            }
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>
